/** GraphQL operations that do not require an Authorization header. */
export const PUBLIC_GRAPHQL_OPERATIONS = ['CurrentMaintenance'] as const;

export type PublicGraphQLOperation = (typeof PUBLIC_GRAPHQL_OPERATIONS)[number];

const publicGraphQLOperations = new Set<string>(PUBLIC_GRAPHQL_OPERATIONS);

export const isPublicGraphQLOperation = (operationName: string | undefined): boolean =>
  operationName != null && publicGraphQLOperations.has(operationName);
